import { ContactActions } from "./branchContactAction";

const initialState = {
  Contact: []

};

const ContactReducer = (state = initialState, action) => {
  switch (action.type) {
    case ContactActions.CONTACT_LIST_SUCCESS:
      return {

        Contact: action.payload.data

      };



    default:
      return state;
  }
};

export default ContactReducer;
